// libs.
import { Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';

// selectors.
import { getEmail } from '@domains/user/store/slices/user-slice/user-slice';
import { useAbortTask } from '@pages/DocumentAuditPage/modules/DocumentTaskDetail/shared/AbortTask/hooks/useAbortTask';
import { setSelectedTask } from '@domains/documents-review/store/slices/document-review-slice';

// interfaces.
import { TaskItem } from '@domains/documents-review/interfaces/interfaces';

// components.
import { AbortTaskModal } from '@pages/DocumentAuditPage/modules/DocumentTaskDetail/shared/FormActions/AbortTaskModal';

// assets.
import { IconRemove } from '@assets/icons';

interface Props {
  task: TaskItem;
}

export const ReassignTaskButton = ({ task }: Props) => {
  const dispatch = useDispatch();
  const { handleOpenAbandonModal } = useAbortTask();
  const email = useSelector(getEmail);

  const handleClickReassign = () => {
    dispatch(setSelectedTask(task));
    handleOpenAbandonModal();
  };

  const isDifferentAgent = task.agent && task.agent !== email;

  if (!isDifferentAgent) return null;

  return (
    <>
      <Button
        variant="text"
        color="error"
        onClick={handleClickReassign}
        className="d-flex flex-1 py-1 px-0 align-items-center justify-content-center text-danger rows"
      >
        <IconRemove /> Reasignar
      </Button>
      <AbortTaskModal />
    </>
  );
};
